import { Select } from 'antd';
import { CSSProperties } from 'react';
import styled from 'styled-components';

const StyledSelect = styled(Select)<{
  borderRadius?: string;
  height?: string;
  lineHeight?: string;
  isFocus?: boolean;
  error?: boolean;
  selectSelectionItemStyle?: CSSProperties;
}>`
  .ant-select-selector {
    border-radius: ${props => props?.borderRadius || '6px !important'};
    height: ${props => props?.height || '44px !important '};
    align-items: center;
    border: 1px solid ${({ error }) => (error ? 'var(--color-10)' : '#d9d9d9')} !important;
    .ant-select-selection-placeholder {
      font-style: italic;
      color: #dcdcdc;
    }
    overflow: hidden;
  }
  &:hover .ant-select-selector {
    border-color: ${({ error }) =>
      error ? 'var(--color-10)' : '#2997ff'} !important;
  }
  &.ant-select-focused .ant-select-selector,
  &.ant-select-open .ant-select-selector {
    border-color: ${({ error }) =>
      error ? 'var(--color-10)' : '#2997ff'} !important;
    box-shadow: ${({ error }) =>
      error
        ? '0 0 0 2px rgba(255,77,79,0.2)'
        : '0 0 0 2px rgba(0,122,255,0.2)'};
  }
  .ant-select-clear {
    transform: translateY(-2px);
  }
  .ant-select-arrow {
    opacity: ${props =>
      props?.value !== null && props?.value !== undefined ? 1 : 0.3};
  }
  .ant-select-selection-item {
    ${props => ({ ...props.selectSelectionItemStyle })}
  }
  .ant-select-selection-overflow {
    flex-wrap: nowrap;
    text-overflow: ellipsis;
    position: relative;
  }
  .ant-select-selection-search-input {
    display: ${props => (props?.isFocus ? 'flex' : 'none')};
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .ant-select-selection-overflow-item.ant-select-selection-overflow-item-suffix {
    order: 3 !important;
    position: relative !important;
    @media (max-width: 1200px) {
      max-width: 70% !important;
    }
    overflow: hidden;
    left: 0px !important;
  }
  .ant-select-selection-search-input {
    height: ${props => props?.height || '44px !important '};
  }
`;

export const CustomSelect = styled(Select)`
  .ant-select-arrow {
    opacity: ${props =>
      props?.value !== null && props?.value !== undefined ? 1 : 0.3};
  }
`;

export const MobileStyledSelect = styled(Select)`
  .ant-select-selector {
    border-radius: 6px !important;
    height: 41px !important; /* Your desired height */
    line-height: 41px !important; /* Match line-height to your height */
    align-items: center;
    .ant-select-selection-placeholder {
      font-style: italic;
      color: #dcdcdc;
    }
  }
`;

export const SelectComp = styled(Select)`
  .ant-select-selector {
    border-radius: 5px !important;
    height: 34px !important; /* Your desired height */
    line-height: 34px !important; /* Match line-height to your height */
    align-items: center;
    .ant-select-selection-placeholder {
      /* font-style: italic; */
      color: #dcdcdc;
    }
  }
`;

export default StyledSelect;
